import React from 'react';
import {connect} from "react-redux";

class ContentContainer extends React.Component {

	render() {
		return <div className={this.props.inApp ? 'content' : 'content under-navbar-content'}>
			{this.props.children}
		</div>;
	}

}

export default connect(
	(state) => {
		return {
			inApp: state.browser.inApp
		}
	},
	(dispatch) => {
		return {}
	}
)(ContentContainer)
